import { Alert, AlertProps } from "@amzn/awsui-components-react";
import { JSX } from "react";

/**
 * Represent the props for the CustomAlert component
 *
 * @interface
 * @property {string} title - The name of the error
 * @property {JSX.Element} content - The content to be displayed for the error
 * @property {AlertProps.Type} type - The type of alert to be rendered
 */
export interface CustomAlertProps {
    title: string;
    content: React.ReactNode;
    type: AlertProps.Type;
}

/**
 * Renders a custom alert
 *
 * @param {string} title - The name of the error
 * @param {JSX.Element} content - The content to be displayed for the error
 * @param {AlertProps.Type} type - The type of alert to be rendered
 * @returns {JSX.Element} An alert component displaying the error message
 */
const CustomAlert = ({ title, content, type }: CustomAlertProps): JSX.Element => (
    <Alert type={type} header={title}>
        {content}
    </Alert>
);

export default CustomAlert;
